<script setup lang="ts">
import { type Component, computed } from "vue";

import DropdownItemWrapper from "~/components/dumb/DropdownItemWrapper.vue";
import { DEFAULT_CHIP_COLOR } from "~/constants/style";
import { XIcon } from "~/icons";
import { useAppStore, usePageStore } from "~/stores";
import { getChipColorsHex } from "~/utils/color";

const props = defineProps<{
  label: string;
  id?: string;
  selected?: boolean;
  colorHex?: string;
  icon?: Component;
  iconArgs?: object;
  replaceEnabled?: boolean;
  disabled?: boolean;
  isMenuItem?: boolean;
}>();

const emit = defineEmits<{
  remove: [];
  replace: [];
}>();

const appStore = useAppStore();
const pageStore = usePageStore();

// Get colors or fallback to default
const colorSet = computed(() => getChipColorsHex(props.colorHex ?? DEFAULT_CHIP_COLOR, pageStore.theme));
</script>

<template>
  <component
    :is="isMenuItem ? DropdownItemWrapper : 'div'"
    :id="id"
    v-bind="{ selected, noPadding: selected && !pageStore.isMobile, replaceEnabled }"
    class="flex items-center justify-between overflow-hidden text-sm"
    :class="!pageStore.isMobile || appStore.searchModalOpen ? 'grow' : 'w-full'"
    @replace="emit('replace')">
    <div
      class="flex min-h-5 items-center justify-center overflow-hidden rounded-sm border pr-1 text-xs select-none"
      :class="icon ? 'pl-1' : label.startsWith('+') ? 'pl-[5px]' : 'pl-1.5'"
      :style="{ color: colorSet.fore, backgroundColor: colorSet.back, borderColor: colorSet.border }">
      <component :is="icon" v-if="icon" v-bind="iconArgs" class="mr-1 icon-sm" />
      <div :title="label" class="mr-0.5 truncate">
        {{ label }}
      </div>
      <div
        v-if="!pageStore.isMobile && selected"
        class="flex cursor-pointer items-center justify-center rounded-sm hover-bg-quiet"
        @click.stop="emit('remove')"
        @keydown.enter.stop="emit('remove')">
        <XIcon class="icon-xs" />
      </div>
    </div>
  </component>
</template>
